import { render } from "./ReportForm.vue?vue&type=template&id=4d3b2d67&scoped=true"
import script from "./ReportForm.vue?vue&type=script&lang=js"
export * from "./ReportForm.vue?vue&type=script&lang=js"

import "./ReportForm.vue?vue&type=style&index=0&id=4d3b2d67&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3b2d67"]])

export default __exports__